import { Plaque } from '../plaque/Plaque';
import { MapHudButton } from '../map_hud_button/MapHudButton';
import starImg from '../../components/atomic/icons/star/star.png';
import { RatingValueText } from './RatingValueText';
import { ChangeRatingCoeffText } from './ChangeRatingCoeffText';
import './RatingScreenButton.css';

type RatingScreenButtonProps = {
  onClick?: () => void;
  /** Dynamic rating value (Figma `rating_value_text`). */
  rating?: string;
  /** Dynamic rating change coefficient (Figma `change_rating_coeff_text`). */
  changeCoeff?: string;
};

/**
 * Figma `window_star` (104:24184) — plaque + star + rating texts.
 * Star (104:24582) positioned relative to plaque `background` (104:24185).
 */
export function RatingScreenButton({
  onClick,
  rating,
  changeCoeff,
}: RatingScreenButtonProps) {
  return (
    <MapHudButton
      className="rating-screen-button"
      ariaLabel={
        rating
          ? `Рейтинг: ${rating}${changeCoeff ? `, ${changeCoeff}` : ''}`
          : 'Рейтинг'
      }
      onClick={onClick}
    >
      <Plaque />
      <img
        className="rating-screen-button__star"
        src={starImg}
        alt=""
        draggable={false}
        aria-hidden
      />
      <RatingValueText value={rating} />
      <ChangeRatingCoeffText value={changeCoeff} />
    </MapHudButton>
  );
}
